import {combineReducers} from 'redux';
import userAuthReducer from './authReducer';
import  dataReducer  from './dataReducer';
import chatReducer from './chatReducer'

export default combineReducers({
  userAuth: userAuthReducer,
  pharmacyData : dataReducer,
  chats : chatReducer
});
